import axios from 'axios';
import * as ActionTypes from '../constants/action-types';
import { statusType } from '../constants/api-responses';
import { formatQuestionData, formatAnswerResponse, formatIntakeForm, isFinalFailure, isFileUploadFailure } from '../utils/helpers';

const INTAKE_FORM_URL = '/my-data/api/ccpa/initialanswers';
const POST_ANSWER_URL = '/my-data/api/ccpa/kbaanswers';
const POST_UNVALIDATED_REQUEST = '/my-data/api/ccpa/submitcase';


function postIntakeForm(formData) {
    return dispatch => {
        dispatch(asyncLoading());
        return axios
            .post(INTAKE_FORM_URL, formatIntakeForm(formData))
            .then(({ data }) => {
                dispatch(handleResponse(data));
            })
            .catch(() => {
                dispatch(clearFormData());
                return dispatch(unhandledError());
            });
    };
}

//function postUnvalidatedRequest

function postUnvalidatedRequest(formData) {
    return dispatch => {
        dispatch(asyncLoading());
        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        }
        return axios
            .post(POST_UNVALIDATED_REQUEST, formatIntakeForm(formData), config)
            .then(({ data }) => {
                dispatch(handleResponse(data));
            })
            .catch(() => {
                dispatch(clearFormData());
                return dispatch(unhandledError());
            });
    };
}

const postQuestionAnswer = answer => {
    return (dispatch, getState) => {
        const kbaResponse = formatAnswerResponse({ answer, state: getState().app });
        return axios
            .post(POST_ANSWER_URL, kbaResponse)
            .then(({ data }) => {
                dispatch(handleResponse(data));
                if (data.transactionStatus === statusType.PASSED) {
                    return false;
                } else {
                    return true;
                }
            })
            .catch(() => {
                dispatch(clearFormData());
                dispatch(unhandledError());
            });
    };
};

const handleResponse = data => {
    const { transactionStatus, transactionReasonCode } = data;
    return dispatch => {
        const showFinalFailure = isFinalFailure(transactionReasonCode);
        const showFileUploadFailure = isFileUploadFailure(transactionReasonCode);
        
        if (transactionStatus === statusType.FAILED && showFinalFailure) {
            dispatch(setFullFailure());
        } else if(showFileUploadFailure) {
            dispatch(setFileUploadFailure());
        } else if (transactionStatus === statusType.FAILED) {
            dispatch(setAuthFailure());
        } else if (transactionStatus === statusType.PENDING) {
            dispatch(setCCPAModel(data.ccpaCaseModel));
            dispatch(setQuestions(formatQuestionData(data)));
        } else if (transactionStatus === statusType.PASSED) {
            dispatch(successFinal());
        } else {
            dispatch(unhandledError());
        }
    };
};

const userTimeout = () => {
    return (dispatch, getState) => {
        const timeoutResponse = formatAnswerResponse({ answer: 0, state: getState().app });
        axios.post(POST_ANSWER_URL, timeoutResponse);
        dispatch(clearFormData());
        dispatch({ type: ActionTypes.TIMEOUT_FAILURE });
    };
};

const clearFormData = () => ({ type: ActionTypes.CLEAR_DATA });

const setRequestType = type => ({ type: ActionTypes.SET_REQUEST_TYPE, payload: type });

const setQuestions = payload => ({
    type: ActionTypes.SET_QUESTIONS,
    payload
});

const setCCPAModel = model => ({
    type: ActionTypes.SET_CCPA_MODEL,
    payload: model
});

const setFullFailure = () => ({
    type: ActionTypes.FULL_FAILURE
});

const setFileUploadFailure = () => ({
    type: ActionTypes.FILE_ERROR
});

const unhandledError = () => ({
    type: ActionTypes.UNHANDLED_ERROR
});

const setAuthFailure = () => ({
    type: ActionTypes.AUTH_FAILURE
});

const asyncLoading = () => ({
    type: ActionTypes.ASYNC_LOADING
});

const successFinal = () => ({
    type: ActionTypes.SUCCESS_FINAL
});

export { postIntakeForm, postQuestionAnswer, setAuthFailure, setRequestType, userTimeout, postUnvalidatedRequest };
